import type { CharacterBattleSnapshot } from '../../core';

export type AnimationKey = string;
export const resolveAnimation = (snapshot: CharacterBattleSnapshot, available: ReadonlySet<string>): AnimationKey => {
  const generic: Record<CharacterBattleSnapshot['state'], string> = {
    Idle: 'idle', Walk: 'walk', Jump: 'jump', Crouch: 'crouch', Guard: 'guard', Hitstun: 'hitstun',
    Knockdown: 'knockdown', CounterAttack: 'counter-response', Super: 'super', KO: 'ko', Attack: 'attack', Special: 'special',
  };
  const requested = (snapshot.state === 'Attack' || snapshot.state === 'Special') && snapshot.currentAttackId !== null
    ? snapshot.currentAttackId : generic[snapshot.state];
  if (available.has(requested)) return requested;
  if (available.has(generic[snapshot.state])) return generic[snapshot.state];
  return available.has('idle') ? 'idle' : 'static';
};
export const airborneInvincibilityAlpha = (enabled: boolean, elapsedMs: number): number =>
  enabled && Math.floor(elapsedMs / (1_000 / 12)) % 2 === 1 ? 0.55 : 1;
